@for (order of orders(); track order) {
  <div class="order">
    <ui-order-history-details [order]="order" [displayFullView]="false"></ui-order-history-details>
    <ui-order-history-actions
      [order]="order"
      (openSrmForm)="onOpenSrmForm(order)"
      (openDocuments)="onOpenDocuments(order)"
      class="order-cell no-border full-width has-actions"
    ></ui-order-history-actions>

    @if (selected()?.panel === 'documents' && selected()?.order?.id === order.id) {
      <ui-order-history-documents [order]="order" (closed)="onPanelClosed()"></ui-order-history-documents>
    }
  </div>
}

@if (selected()?.panel === 'srm') {
  <div class="order-history-srm-overlay">
    <div class="order-history-srm-overlay-form">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Anfragen & Reklamationen</mat-card-title>
          <ui-icon-button
            icon="xmark-large"
            buttonStyle="unthemed"
            iconStyle="light"
            (clicked)="onPanelClosed()"
          ></ui-icon-button>
        </mat-card-header>

        <mat-card-content>
          <ui-srm-create-form
            [order]="selected()?.order"
            (formClosed)="onPanelClosed()"
            location="orders"
          ></ui-srm-create-form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}
